import { LayoutManager } from "../Managers/LayoutManager";
import { Scaling } from "../Utils/Scaling";
import { LayoutSwitchElementExtended } from "./LayoutSwitchElementExtended";

export class LayoutManagerExtended extends LayoutManager {
    constructor() {
        super();

        if (Scaling.Emitter != null) {
            Scaling.Emitter.on(Scaling.EventLeftHand, this.onLeftHandLayoutChange.bind(this));
        }
    }

    private onLeftHandLayoutChange(isLeftHand: boolean): void {
        this.updateLeftHandLayoutElements(isLeftHand);
    }

    private updateLeftHandLayoutElements(isLeftHand: boolean): void {
        for (let i = 0; i < LayoutManager.LayoutElements.length; i++) {
            if (LayoutManager.LayoutElements[i] instanceof LayoutSwitchElementExtended) {
                (LayoutManager.LayoutElements[i] as LayoutSwitchElementExtended).onLeftHandLayoutChange(isLeftHand);
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/LayoutManagerExtended.ts
 **/